// Copyright text placeholder, Warner Bros. Discovery, Inc.

import { AbstractAccount } from '@wbd/beam-ctv-platform-adapters';

export class PlayStationAccount extends AbstractAccount {}
